<template>
  <div style="width: 100%">
    <el-row v-if="progress == 2">
      <el-col :span="15" style="text-align: left;margin-left: 45px">
        <h1 class="c1" :style="{color: getColor(word)}">{{word.content1}}</h1>
      </el-col>
      <el-col v-if="type == 'write'" :span="1">
        <i v-if="inputOk" class="el-icon-check" style="font-size: 3em;color: #5DBF39;margin: 55px 0 0 0"></i>
        <i v-else class="el-icon-close" style="font-size: 3em;color: #BF3939;margin: 55px 0 0 0"></i>
      </el-col>
      <el-col :span="4">
        <h1 class="c2" :style="{color: getColor(word)}">{{word.content2}}</h1>
      </el-col>
      <el-col :span="2">
        <i @click="playAudio(word.content7)" :style="{fontSize: '3em',color: getColor(word),margin: '35px 0 0 0'}" class="el-icon-video-play"></i>
      </el-col>
    </el-row>
    <!-- 输入框 -->
    <div v-else-if="type == 'write'" class="word">
      <el-row>
        <el-col :span="12">
          <input type="text" style="float: left" placeholder="拼写出你听到的单词" v-model="input" class="text-input" @keydown.enter="checkAnswer">
        </el-col>
        <el-col :span="2" :offset="10">
          <el-button type="primary" class="submit-button" @click="checkAnswer">提交</el-button>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  props: ['word','progress','type','learnProgress'],
  data() {
    return {
      input: '',
      inputOk: false,
    }
  },
  methods: {
    playAudio(url) {
      let audio = new Audio()
      audio.src = `https://awesome-platform.oss-cn-shanghai.aliyuncs.com/quick/v${url}`
      audio.play();
    },
    checkAnswer() {
      let i = this.input
      let a = this.word.content1
      i = i.trim().toLowerCase()
      a = a.trim().toLowerCase()
      if (i == a) {
        this.inputOk = true
        this.$emit('wordOver',1)
      } else {
        this.inputOk = false
        this.$emit('wordOver',3)
      }
      this.input = ''
      this.$emit('progressChange',2)
    },
    contain(arr, item) {
      let flag = false;
      for (let i = 0; i < arr.length; i++) {
        if (item == arr[i]) {
          flag = true
        }
      }
      return flag
    },
    getColor(word) {
      if (this.contain(this.learnProgress.miss, word)) {
        return '#ac1a1a'
      } else if (this.contain(this.learnProgress.unsure, word)) {
        return '#ac681a'
      } else {
        return '#334970ee'
      }
    }
  },
}
</script>

<style scoped>
.text-input{
  z-index: 1;
  width: 660px;
  height: 60px;
  text-rendering: auto;
  color: -internal-light-dark-color(black, white);
  letter-spacing: normal;
  word-spacing: normal;
  text-transform: none;
  text-indent: 20px;
  text-shadow: none;
  display: inline-block;
  text-align: start;
  -webkit-appearance: textfield;
  background-color: -internal-light-dark-color(white, black);
  -webkit-rtl-ordering: logical;
  cursor: text;
  margin: 0;
  font: 300 35px Arial;
  padding: 0px 0px;
  border-width: 0px;
  border-color: transparent;
  border-image: initial;
  border-radius: 40px 0 0 40px;
  outline: none;
}
::-webkit-input-placeholder { /* WebKit browsers */
  color: #888;
  font: 100 0.8em sans-serif;
}

::-moz-placeholder { /* Mozilla Firefox 19+ */
  color: #888;
  font: 100 0.8em sans-serif;
}

:-ms-input-placeholder { /* Internet Explorer 10+ */
  color: #888;
  font: 100 0.8em sans-serif;
}
.topleft{
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
}
.c1{
  font-size: 3em;
  margin: 25px 0 0 50px;
}
.c2{
  font-size: 1.8em;
  margin: 40px 0 0 20px;
}
.word{
  width: 780px;
  margin: 70px 80px;
}
.submit-button{
  float: right;
  width: 120px;
  height: 60px;
  border-radius: 0 40px 40px 0;
  font-size: 25px;
  background-color: #334970ee;
}
@media screen and (max-width: 1400px){
  .word{
    width: 630px;
    margin: 30px 30px 0px 30px;
  }
  .text-input{
    width: 600px;
  }
}
</style>
